import { useEffect, useState } from "react";

const SearchInputWithResults = ({
  value: initialValue = "",
  onSelectUser,
  placeholder = "Pesquisar...",
  fetchResults,
  onFocusInput
}) => {
  const [internalValue, setInternalValue] = useState(initialValue);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => setInternalValue(initialValue), [initialValue]);

  useEffect(() => {
    if (!internalValue.trim()) {
      setResults([]);
      return;
    }
    const timer = setTimeout(async () => {
      try {
        setLoading(true);
        const data = await fetchResults(internalValue);
        setResults(data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [internalValue]);

  const handleSelect = (item) => {
    onSelectUser(item);
    setInternalValue("");
    setResults([]);
    setIsFocused(false);
  };

  return (
    <div className="w-full relative mb-4 max-w-lg">
      <input
        type="text"
        value={internalValue}
        placeholder={placeholder}
        readOnly
        onFocus={() => {
          setIsFocused(true);
          if (onFocusInput) onFocusInput();
        }}
        className="w-full px-4 py-3 border-2 border-custom_blue rounded-xl shadow-inner focus:outline-none focus:ring-2 focus:ring-custom_green text-xl md:text-2xl bg-white text-black placeholder-gray-400"
      />

      {internalValue.trim() && (
        <div className="absolute top-full left-0 w-full mt-1 max-h-64 overflow-y-auto border-2 border-gray-200 rounded-xl shadow-inner bg-white z-40">
          {loading ? (
            <div className="p-4 text-center text-gray-500">Carregando...</div>
          ) : results.length > 0 ? (
            results.map((item, index) => (
              <div
                key={index}
                onClick={() => handleSelect(item)}
                className="flex items-center gap-4 px-4 py-2 hover:bg-gray-200 cursor-pointer transition"
              >
                {item.imageData ? (
                  <img
                    src={item.imageData}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center text-sm font-bold">
                    {(item.name?.[0] || "U").toUpperCase()}
                  </div>
                )}
                <div className="flex flex-col">
                  <span className="text-base font-semibold">{item.name}</span>
                  <span className="text-sm text-gray-500">{item.grade}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="p-4 text-center text-gray-500">Nenhum usuário encontrado</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchInputWithResults;
